import React from 'react';
import { Section } from '../ui/Section';
import { Lock, Key } from 'lucide-react';
export function Mechanism() {
  return <Section theme="black" className="border-b border-gold-hairline" data-id="element-78">
      <div className="max-w-3xl mx-auto" data-id="element-79">
        <div className="mb-6 flex flex-col items-center" data-id="element-80">
          <div className="flex items-center gap-4 mb-4" data-id="element-81">
            <div className="h-[1px] w-8 bg-gold/30" data-id="element-82"></div>
            <span className="text-gold text-xs font-semibold tracking-[0.2em] uppercase" data-id="element-83">
              The Unique Mechanism
            </span>
            <div className="h-[1px] w-8 bg-gold/30" data-id="element-84"></div>
          </div>
        </div>

        <div className="bg-onyx p-1 md:p-2 shadow-editorial-dark mt-10" data-id="element-85">
          <div className="border border-gold-hairline p-8 md:p-12 relative overflow-hidden h-full" data-id="element-86">
            {/* Decorative background element */}
            <div className="absolute -right-10 -top-10 opacity-5" data-id="element-87">
              <Lock className="w-64 h-64 text-gold" data-id="element-88" />
            </div>

            <div className="relative z-10" data-id="element-89">
              <div className="flex items-center gap-4 mb-8 pb-8 border-b border-gold-hairline" data-id="element-90">
                <Key className="w-8 h-8 text-gold" data-id="element-91" />
                <h2 className="text-3xl md:text-4xl font-serif font-medium text-gold" data-id="element-92">
                  The Backdoor National Auction Protocol
                </h2>
              </div>

              <div className="space-y-6 text-lg text-bone-muted leading-relaxed font-sans" data-id="element-93">
                <p data-id="element-94">
                  This isn't just about bidding; it's a specific{' '}
                  <strong className="text-bone font-medium" data-id="element-95">
                    "Bridge Strategy"
                  </strong>{' '}
                  for the 2026 market.
                </p>
                <p className="text-2xl font-serif font-medium italic text-bone border-l-[1px] border-gold pl-6 py-2 my-8" data-id="element-96">
                  We use the Auction-to-Refi Loophole.
                </p>
                <p data-id="element-97">
                  This allows you to secure a property at an auction price using
                  short-term leverage and then flip it into a traditional 3.5%
                  down FHA mortgage.
                </p>
                <p data-id="element-98">
                  You get the auction price, the bank's money, and your
                  landlord's respect—all while keeping your savings intact.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}